import { Component, Input, OnInit, SimpleChanges, ViewChild, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GridOptions, RowNode } from 'ag-grid';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { OnDemandDriversService } from 'app/pages/on-demand-drivers/on-demand-drivers.service';
import { T2CardComponent } from 'app/trip2-theme/components/t2-card/t2-card.component';

@Component({
  selector: 'app-send-message',
  templateUrl: './send-message.component.html',
  styleUrls: ['./send-message.component.scss']
})
export class SendMessageComponent implements OnInit {

  @ViewChild('messageModal') modal: T2CardComponent;
  @Input('optionsConfig') optionsConfig: SendMessageI;
  @Output() eventAfterSending: EventEmitter <any> = new EventEmitter <any>();

  protected message = '';
  protected PlainMessage = '';
  protected subject = '';
  protected showLoading = false;
  protected typeMessage = {
    email: true,
    phone: false,
    title: 'Send Message'
  };

  dataConf: SendMessageI;

  protected selectedDrivers: any[] = [];
  formSendMessage: FormGroup;

  get emailCtrl(): AbstractControl { return this.formSendMessage.get('email') }
  get phoneCtrl(): AbstractControl { return this.formSendMessage.get('phone') }
  get messageCtrl(): AbstractControl { return this.formSendMessage.get('message') }
  get subjectCtrl(): AbstractControl { return this.formSendMessage.get('subject') }
  get isEmailMessage(): boolean { return this.formSendMessage.get('email').value; }
  get isSmsMessage(): boolean { return this.formSendMessage.get('phone').value; }
  get validSelectMessage(): boolean { return !this.isEmailMessage && !this.isSmsMessage; }
  get textMessage(): string {
    let str = '';
    if (this.emailCtrl.value && !this.phoneCtrl.value) { str = 'email';
    } else if (this.phoneCtrl.value && !this.emailCtrl.value) { str += 'SMS';
    } else { str = 'email and SMS'; }
    return str;
  }

  constructor(
    protected _service: OnDemandDriversService,
    private toastrAlertHelper: ToastrAlertHelper,
    private fb: FormBuilder,
    private sweetAlertHelper: SweetAlertHelper,
  ) {this.initForm();}

  ngOnInit(): void {
    this.formValidations();
  }

  initForm(): void {
    this.formSendMessage = this.fb.group({
      email: [true],
      phone: [false],
      subject: ['', Validators.required],
      message: ['', Validators.required],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['optionsConfig'] !== undefined) {
      this.dataConf = this.optionsConfig;
      // this.onResetForm(true);
    }
  }

  showMessageModule(objGrid: GridOptions, selectedDrivers: any[]): void {
    this.selectedDrivers = selectedDrivers;
    objGrid.api.forEachNodeAfterFilter((res: RowNode) => {
      if (res.isSelected()) {
        this.selectedDrivers.push(res.data.userprofileid);
      }
    });

    if (this.selectedDrivers.length > 0) {
      this.modal.open();
      this.onResetForm(true);
    } else {
      this.sweetAlertHelper.createCustomAlert({
        title: 'Attention!',
        text: 'You must select a driver to send a message',
        type: 'info',
      });
    }
  }

  sendMessageAction(): void {
    if (this.phoneCtrl.value && !this.emailCtrl.value) { this.subjectCtrl.patchValue(''); }
    this.sweetAlertHelper.createCustomAlert({
      title: '',
      text: `Are you sure you want to send this message by ${this.textMessage} to the selected ${this.selectedDrivers.length} drivers?`,
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then((result: any) => {
      if (result.value) {
        if (!this.phoneCtrl.value && !this.emailCtrl.value) {
          this.toastrAlertHelper.error('Please check Email or SMS');
          return;
        }

        this.modal.viewProgressBar(true);
        this.typeMessage.title = 'Sending Message(s)...';
        this.showLoading = true;
        const data = {
          users: this.selectedDrivers,
          sendmethod: this.getTypeMessage(),
          message: this.message,            // TODO: EMAIL TEXT.
          PlainMessage: this.PlainMessage,  // TODO: CELL TEXT.
          subject: this.subjectCtrl.value
        };

        this._service
        .sendMessage(data)
        .finally(() => this.modal.viewProgressBar(false))
        .subscribe(
          (res: any) => {
            this.eventAfterSending.emit(res);
            this.message = '';
            this.PlainMessage = '';
            this.subject = '';
            this.showLoading = false;
            this.typeMessage.title = 'Send Message';
            this.formSendMessage.reset();
            this.modal.close();
          },
          (error: any) => { this.sweetAlertHelper.createCustomAlert({ title: 'Error', text: error.message, type: 'error'}); }
        );
      }
    });
  }

  onResetForm(action: any): void {
    this.formSendMessage.reset();
    this.emailCtrl.patchValue(false);
    this.phoneCtrl.patchValue(false);
    this.PlainMessage = '';
    this.message = '';
    if (!action) { this.modal.close(); }
    this.showLoading = false;
    this.modal.viewProgressBar(false);
  }

  onEmitterText(params: any): void {
    const plainClain = params.editable.innerText;
    const ONE_ENTER = plainClain.replace(/\n\n/g, '\n');
    const TWO_ENTER = ONE_ENTER.replace(/(\n\s*?\n)\s*\n/g, '\n\n');
    this.formSendMessage.patchValue({ message: TWO_ENTER });
    this.message = params.html;    //:TODO: EMAIL
    this.PlainMessage = TWO_ENTER !== undefined && TWO_ENTER !== null ? TWO_ENTER.trim() : '';  //:TODO: CELL
  }

  formValidations(): void {
    this.phoneCtrl.valueChanges.subscribe({
      next: () => {
        if (this.isSmsMessage) {
          this.messageCtrl.setValidators([Validators.maxLength(300)]);
        } else {
          this.messageCtrl.clearValidators();
        }
        this.messageCtrl.updateValueAndValidity();
      },
      error: (er: any) => this.sweetAlertHelper.createCustomAlert({ title: 'Error in the phone field', text: er, type: 'error'})
    })

    this.emailCtrl.valueChanges.subscribe({
      next: () => {
        if (!this.isEmailMessage) { this.subjectCtrl.clearValidators(); }
        this.subjectCtrl.updateValueAndValidity();
      },
      error: (er: any) => this.sweetAlertHelper.createCustomAlert({ title: 'Error in the email field', text: er, type: 'error'})
    })
  }

  getTypeMessage(): string {
    if (this.phoneCtrl.value && this.emailCtrl.value) { return 'All'; }
    if (this.phoneCtrl.value && !this.emailCtrl.value) { return 'Phone'; }
    if (!this.phoneCtrl.value && this.emailCtrl.value) { return 'Email'; }
  }
}

export interface SendMessageI {
  modal: boolean;
  draggable: boolean;
  title: string;
  grid: GridOptions
}



// WEBPACK FOOTER //
// ./src/app/utils/send-message/components/send-message/send-message.component.ts